module.exports = __webpack_public_path__ + "static/media/Aug_2025_5.ca6ad48a.webp";